import { CommonModule } from '@angular/common'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { NgModule } from '@angular/core'

import { AuthGuard } from './auth-guard.service'
import { AuthInterceptor } from './auth.interceptor'
import { AuthService } from './auth.service'

@NgModule({
  imports: [CommonModule],
  providers: [
    AuthService,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
})
export class AuthModule {}
